import JSZip from "jszip";

export async function buildKmz(kmlString: string, iconBlob?: Blob | null): Promise<Blob> {
  const zip = new JSZip();
  zip.file("doc.kml", kmlString);
  if (iconBlob) zip.file("images/icon-1.png", iconBlob);
  return zip.generateAsync({
    type: "blob",
    mimeType: "application/vnd.google-earth.kmz",
  });
}
